<template>
  <div>
    <app-header></app-header>
    <div id="container">
      <div class="clear"></div>
      <div>
        <!-- <div class="vaacuum_50"></div> -->
        <!-- <div class="vaacuum_50"></div> -->

        <div id="center">
          <div class="logo">
            <!-- <a href="#">
              <img
                src="/frontend/images/Azcloud_H_SVG.SVG"
                alt="Ana səhifə"
                width="350"
                height="150"
              />
            </a> -->
          </div>
          <div class="vaacuum"></div>

          <div id="searchform">
            <div id="search">
              <div id="search-line-code">
                <div id="search-dot-code">
                  <input type="text" id="idnum3" size="3" maxlength="3" value="012" disabled />
                </div>
              </div>
              <div id="search-line">
                <input type="hidden" name="num" id="idnum" />
                <div id="search-dot-white">
                  <input type="text" id="idnum1" size="1" maxlength="1" value="2" disabled />
                </div>
                <div id="search-vacuum"></div>
                <div id="search-dot-white">
                  <input type="text" id="idnum2" size="1" maxlength="1" value="1" disabled />
                </div>
                <div id="search-vacuum"></div>
                <div id="search-dot-white">
                  <input type="text" id="idnum3" size="1" maxlength="1" value="0" disabled />
                </div>
                <div id="search-vacuum"></div>
                <div id="search-dot-blue">
                  <input
                    type="text"
                    id="1"
                    size="1"
                    maxlength="1"
                    v-model="number1"
                    @keyup.enter="search"
                    @keyup="onlyNumber($event, $event.target.id)"
                  />
                </div>
                <div id="search-vacuum"></div>
                <div id="search-dot-blue">
                  <input
                    type="text"
                    id="2"
                    size="1"
                    maxlength="1"
                    v-model="number2"
                    @keyup="onlyNumber($event, $event.target.id)"
                    @keyup.enter="search"
                  />
                </div>
                <div id="search-vacuum"></div>
                <div id="search-dot-blue">
                  <input
                    type="text"
                    id="3"
                    size="1"
                    maxlength="1"
                    v-model="number3"
                    @keyup="onlyNumber($event, $event.target.id)"
                    @keyup.enter="search"
                  />
                </div>
                <div id="search-vacuum"></div>
                <div id="search-dot-blue">
                  <input
                    type="text"
                    id="4"
                    size="1"
                    maxlength="1"
                    v-model="number4"
                    @keyup="onlyNumber($event, $event.target.id)"
                    @keyup.enter="search"
                  />
                </div>
              </div>
              <div id="search-vacuum"></div>
              <div>
                <div id="submit">
                  <input @click="search" type="button" name="button" id="button" value="Axtar" />
                </div>

                <div id="submit">
                  <input type="submit" name="button" id="button" value="✕" @click="reset" />
                </div>
              </div>
            </div>
            <div id="search-category">
              <button @click="allNumbers">
                Bütün
                <br />nömrələr
              </button>
              <button @click="vipNumbers">
                VIP
                <br />nömrələr
              </button>
              <button @click="category1">Kateqoriya 1</button>
              <button @click="category2">Kateqoriya 2</button>
              <button @click="category3">Kateqoriya 3</button>
              <button @click="category4">Kateqoriya 4</button>
              <button @click="standardNumbers">
                Standart
                <br />nömrələr
              </button>
            </div>
          </div>

          <div class="clear"></div>

          <div class="vaacuum_75"></div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import appHeader from "./Header.vue";
import appFooter from "./Footer.vue";
import { store } from "../../store.js";
export default {
  components: {
    appHeader,
    appFooter
  },
  data: function () {
    return {
      number1: "",
      number2: "",
      number3: "",
      number4: "",
    };
  },
  methods: {
    onlyNumber: function ($event, id) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if($event.key == 'Backspace')
      document.getElementById(parseInt(id)-1).focus();
      if((keyCode < 48 || keyCode > 57) && (keyCode < 96 || keyCode > 105)) {
        document.getElementById(parseInt(id)).value = '';
      }else{
        if(document.getElementById(parseInt(id)+1).value == '')
        document.getElementById(parseInt(id)+1).focus();
      }
    },
    search: function () {
      if (this.number1 == "") this.number1 = "x";
      if (this.number2 == "") this.number2 = "x";
      if (this.number3 == "") this.number3 = "x";
      if (this.number4 == "") this.number4 = "x";
      store.convert(true);
      this.$router.push(
        "/az/sip/210" +
          this.number1 +
          this.number2 +
          this.number3 +
          this.number4 +
          "/1/Price/Desc"
      );
      if (this.number1 == "x") this.number1 = "";
      if (this.number2 == "x") this.number2 = "";
      if (this.number3 == "x") this.number3 = "";
      if (this.number4 == "x") this.number4 = "";
    },
    allNumbers: function () {
      store.convert(true);
      this.$router.push("/az/sip/all/1/Price/Desc");
    },
    vipNumbers: function () {
      store.convert(true);
      this.$router.push("/az/sip/VIP/1/Price/Desc");
    },
    category1: function () {
      store.convert(true);
      this.$router.push("/az/sip/1st/1/Price/Desc");
    },
    category2: function () {
      store.convert(true);
      this.$router.push("/az/sip/2nd/1/Price/Desc");
    },
    category3: function () {
      store.convert(true);
      this.$router.push("/az/sip/3rd/1/Price/Desc");
    },
    category4: function () {
      store.convert(true);
      this.$router.push("/az/sip/4th/1/Price/Desc");
    },
    standardNumbers: function () {
      store.convert(true);
      this.$router.push("/az/sip/standard/1/Price/Desc");
    },
    reset: function () {
      this.number1 = "";
      this.number2 = "";
      this.number3 = "";
      this.number4 = "";
    }
  }
};
</script>

<style scoped>
/* search category */
#search-category {
  width: 800px;
  float: left;
  position: relative;
  left: 11px;
}
#search-category button {
  width: 100px;
  height: 50px;
  color: #ffffff;
  margin-left: 10px;
  margin-top: 10px;
  float: left;
  background-color: #29b8fd;
  border: 2px solid #29b8fd;
  border-radius: 5px;
}
#search-category button:hover {
  background-color: #120ed1;
  border: 2px solid #120ed1;
  color: #fff;
  opacity: 1;
}

input[type="text"]:disabled {
  background-color: #acb1b6;
}
#container {
  width: 100%;
}
#search {
  width: 785px;
  height: 75px;
  background-color: #18396a;
  border-radius: 5px;
  padding: 12px;
  margin: 0 auto;
}

#search-line-submit input:focus,
#search-line-submit input:focus {
  border: 2px solid #120ed1;
  cursor: pointer;
  color: #120ed1;
  opacity: 1;
  outline: none;
}

#search-line input:hover,
#search-line input:focus{
  cursor: pointer;
  opacity: 1;
  outline: none;
}

#search-line-code input:hover,
#search-line-code input:focus{
  cursor: pointer;
  opacity: 1;
  outline: none;
}

/* SUBMIT */
#submit {
  width: 115px;
  float: left;
}
#submit input {
  width: 100px;
  height: 50px;
  font: normal 1.8em/1.2em Arial, Helvetica, sans-serif;
  padding: 2px;
  border-radius: 5px;
  border: 2px solid #100d9c;
  background-color: #fff;
  color: #120ed1;
  opacity: 0.95;
}
#submit input:hover {
  background-color: #29b8fd;
  color: #fff;
  opacity: 1;
}

/* SEARCH-LINE-SUBMIT */
#search-line-submit {
  width: 250px;
  float: left;
  margin-left: 10px;
}

#search-line-submit input {
  width: 100px;
  height: 40px;
  border: 2px solid #120ed1;
  font: normal 1.8em/1.4em Arial, Helvetica, sans-serif;
  padding: 2px;
  text-align: center;
  margin-right: 5px;
  border-radius: 5px;
  color: #120ed1;
  opacity: 0.95;
}
#search-dot-submit {
  float: left;
}
#search-dot-reset {
  float: left;
}

/* SEARCH-LINE-CODE */
#search-line-code {
  width: 85px;
  float: left;
  margin-left: 10px;
}
#search-line-code input {
  width: 80px;
  height: 50px;
  border: 2px solid #100d9c;
  font: normal 1.8em/1.4em Arial, Helvetica, sans-serif;
  padding: 2px;
  text-align: center;
  margin-right: 5px;
  border-radius: 5px;
  color: #fff;
  opacity: 0.95;
}
#search-dot-code {
  float: left;
}

/* SEARCH-LINE */
#search-line {
  width: 415px;
  float: left;
  margin-left: 10px;
}
#search-line input {
  width: 50px;
  height: 50px;
  border: 2px solid #100d9c;
  font: normal 1.8em/1.4em Arial, Helvetica, sans-serif;
  padding: 2px;
  text-align: center;
  /* margin-right: 5px; */
  border-radius: 5px;
  
  opacity: 0.95;
}
#search-dot-white {
  float: left;
  color: #fff;
}
#search-dot-blue {
  float: left;
  color: #100d9c;
}

/* CLEAR */
.clear {
  clear: both;
}
#clear {
  clear: both;
}

/* CENTER */
#center {
  width: 806px;
  margin: 0 auto;
}
#center .logo {
  margin: 0 auto;
  width: 350px;
  height: 140px;
}
#center .search {
  height: 45px;
  width: 555px;
  margin-top: 20px;
}

/* vacuum */
#search-vacuum {
  width: 10px;
  height: 30px;
  float: left;
  border: #fff;
}
.vaacuum {
  height: 20px;
  width: 100%;
  border: 0;
  clear: both;
}
.vaacuum_75 {
  height: 75px;
  width: 100%;
  border: 0;
  clear: both;
}
.vaacuum_50 {
  height: 50px;
  width: 100%;
  border: 0;
  clear: both;
}

/* reset */
#reset {
  width: 55px;
  height: 40px;
  position: relative;
  left: 600px;
  bottom: 93px;
}

#reset input {
  width: 70px;
  height: 40px;
  font: normal 2em/1.2em Arial, Helvetica, sans-serif;
  padding: 2px;
  border-radius: 5px;
  border: 2px solid #633493;
  background-color: #fff;
  color: #633493;
  opacity: 0.95;
}
#reset input:focus,
#reset input:hover {
  border: 2px solid #633493;
  cursor: pointer;
  background-color: #fff;
  color: #633493;
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/AZ/Home.vue